import { IntroScreenUIConfig } from "../../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../../components/ui/scenario-info-ui";
import GameManager from "../../cvp-webgames-core/GameManager";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../../cvp-webgames-core/pre-caching/pre-cache-item";
import { PageType } from "../../misc/tools";
import { GameBaseScenario } from "../GameBaseScenario";
import SurgeryWardComponentsStep0Component from "./components/surgery-ward-components-step0/surgery-ward-components-step0";
import SurgeryWardComponentsStep0Part1 from "./components/surgery-ward-components-step0/surgery-ward-components-step0-parts/surgery-ward-components-step0-part1";
import SurgeryWardComponentsStep1Component from "./components/surgery-ward-components-step1/surgery-ward-components-step1";
import SurgeryWardComponentsStep1Part1 from "./components/surgery-ward-components-step1/surgery-ward-components-step1-parts/surgery-ward-components-step1-part1";
import SurgeryWardComponentsStep2Component from "./components/surgery-ward-components-step2/surgery-ward-components-step2";
import SurgeryWardComponentsStep2Part1 from "./components/surgery-ward-components-step2/surgery-ward-components-step2-parts/surgery-ward-components-step2-part1";

class Scenario6SurgeryWardVideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Scenario 6 Surgery Ward';
    }
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'Scenario 6 Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario06/sc06-cinematic/cin-sc-6.mp4',
				chapterIds: [
					'Chapter 1'
				]
			},
			{
				key: 'MixedMedia',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario06/sc06-mentor/mntr-sc-06.mp4', // change this
				chapterIds: [
					'step-2'// alan to update premiere file with audios lol at the end of the time code.
				]
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario06/sc06-mentor/mntr-sc-06.mp4', // change this
				chapterIds: [
					'scenario6-3', //question 1 correct - don't delete comment!
					'scenario6-4', //question 1 incorrect - don't delete comment!
					'scenario6-5', //question 1 other option - don't delete comment!
					'scenario6-7',//question 2 correct - don't delete comment!
					'scenario6-8', //question 2 incorrect - don't delete comment!
					'scenario6-9', //question 2 other option - don't delete comment!
					'scenario6-12', //question 3 correct - don't delete comment!
					'scenario6-13', //question 3 incorrect - don't delete comment!
					'scenario6-17', //question 4 correct - don't delete comment!
					'scenario6-16', //question 4 incorrect - don't delete comment!
					'scenario6-22', //question 4 other option - don't delete comment!
					'scenario6-20', //question 5 correct - don't delete comment!
					'scenario6-19', //question 5 incorrect - don't delete comment! need to check this on the content!!! missing from art team.
					'scenario6-1', //scenario info need to check this on the content!!! missing from art team.
					'scenario6-21' //scenario review need to check this on the content!!! missing from art team.
				]
			}
		];
	}
}

export const scenario6SurgeryWardVideoSegments = new Scenario6SurgeryWardVideoSegments();

class Scenario6SurgeryWardAudioCaching extends PreCacheItem {
    public audioKeys = {
        question1: 'question1',
        question2: 'question2',
        question3: 'question3',
        question4: 'question4',
        question5: 'question5'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question1,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-06/mentor/jcdst-mentor-vo-scn-06-04.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question2,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-06/mentor/jcdst-mentor-vo-scn-06-09.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question3,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-06/mentor/jcdst-mentor-vo-scn-06-15.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question4,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-06/mentor/jcdst-mentor-vo-scn-06-19.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question5,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-06/mentor/jcdst-mentor-vo-scn-06-24.mp3'
			}
		];
	}
}

export const scenario6SurgeryWardAudioCaching = new Scenario6SurgeryWardAudioCaching();

export default class Scenario6SurgeryWard extends GameBaseScenario {
	public comp1Step1FirstSelectedChoiceIndex: number = -1;
	public getMentorVideoURLs(): SingleVideoSegmentItem[] {
		return [
			scenario6SurgeryWardVideoSegments.getItemByKey('MixedMedia'),
			scenario6SurgeryWardVideoSegments.getItemByKey('Feedback'),
		] 
	}
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return {
			scenarioId: PageType.Scenario6SurgeryWard,
			title: 'Acute Surgery Unit',
			subtitle: 'Situation/Background',
			img: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png',
			description: `
				<p class="small-text" style="margin: 20px; text-align: center">
				After this learning activity you will be able to apply the Just Culture Decision Support Tool after an adverse event occurs.
				
				Medication error – incorrect patient received Morphine Sulfate 2mg. Physician and Nursing 
				Supervisor immediately notified of error. Patient monitored closely, with no adverse effects noted.
				</p>
			`,
			mentorVideoUrl: scenario6SurgeryWardVideoSegments.getItemByKey('Feedback').src,
			mentorChapterId: scenario6SurgeryWardVideoSegments.getItemByKey('Feedback').chapterIds[13]
		}
    }
	public resumeScenarioFromArea(areaIndx: number): void {
		switch(areaIndx) {
			case 0:
				(this.step0Component.parts[0] as SurgeryWardComponentsStep0Part1).section2();
				break;
			case 1:
				(this.step0Component.parts[0] as SurgeryWardComponentsStep0Part1).section3();
				break;
			case 2:
				(this.step1Component.parts[0] as SurgeryWardComponentsStep1Part1).section2();
				break;
			case 3:
				(this.step1Component.parts[0] as SurgeryWardComponentsStep1Part1).section3();
				break;
			case 4:
				(this.step2Component.parts[0] as SurgeryWardComponentsStep2Part1).section1();
				break;
			case 5:
				(this.step2Component.parts[0] as SurgeryWardComponentsStep2Part1).section2();
				break;
			case 6:
				(this.step1Component.parts[0] as SurgeryWardComponentsStep1Part1).section1();
				break;
		}
	}

	//VALUES BELOW ARE FOR DEBUG PURPOSES IN CASE STEP 1 is SKIPPED
	// public comp1Step1FirstSelectedChoiceIndex: number = 0;
	public scenarioId(): PageType {
		return PageType.Scenario6SurgeryWard;
    }

	private video: SingleVideoSegmentItem = scenario6SurgeryWardVideoSegments.getItemByKey('Scenario 6 Video 1');
	public getScenarioVideoURL(): string {
		return this.video.src;
	}
	public introScreenInfo(): IntroScreenUIConfig {
		return {
		title: 'Acute Surgery Unit',
		subtitle: 'Incident Report',
		name: 'Kelly',
		position: 'Nurse',
		time: '9:00 am',
		place: 'Acute Surgery Unit',
		desc: `Medication error – incorrect patient received Morphine Sulfate 2mg. Physician and Nursing Supervisor 
		immediately notified of error. Patient monitored closely, with no adverse effects noted.`,
		repeat: 'No',
		okButton: 'Continue'
		}
	}

	private step0Component = new SurgeryWardComponentsStep0Component({
		scenario: this,
		onDone: () => {
			this.goToStep1Component();
		}
	})

	private step1Component = new SurgeryWardComponentsStep1Component({
		scenario: this,
		onDone: () => {
			this.goToStep2Component();
		}
	})

	private step2Component = new SurgeryWardComponentsStep2Component({
		scenario: this,
		onDone: () => {
			this.uiWrapper.displayAAR();
		}
	})

	private parts: BaseScenarioPart<GameBaseScenario>[] = [].concat(this.step0Component.parts)
		.concat(this.step1Component.parts)
		.concat(this.step2Component.parts);

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
		this._setupStep0Component();
		this._setupStep1Component();
		this._setupStep2Component();
	}

	start() {
		this.goToStep0Component();
	}

	private _setupStep0Component() {
		this.step0Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep1Component() {
		this.step1Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep2Component() {
		this.step2Component.config.part1Config = {
			videoUrl: this.video.src
		}
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	goToStep0Component() {
		this.step0Component.start();
	}

	goToStep1Component() {
		this.step1Component.start();
	}

	goToStep2Component() {
		this.step2Component.start();
	}
}